import TimeAgo from "react-timeago-i18n";
import { TIMEAGO_TEXT } from 'utilities/global.variables';
import { formatCurrency, isOlderThan, ownedValue } from 'utilities/global.functions';
import { SealPercentIcon, PercentIcon, WarningCircleIcon, EyeClosedIcon, EyeSlashIcon, UsersIcon } from "@phosphor-icons/react";

const IndividualTileCard = (props) => {
  const { name, description, classification, valuation, ownership, updated, include_networth } = props.item;

  return (
    <>
      <div className="Individual " onClick={() => props.onClickHandler()}>
        <div className="card flex col space r4-3">
          <div className="flex row space">
            <div>
              <p className="medium truncate-1 ">{name}</p>
              <p className="regular o60">{description}</p>
            </div>
            <div></div>
          </div>

          <div>
            <p className="number large">{formatCurrency(Math.abs(ownedValue(valuation, ownership)))}</p>

            <div className="flex row center small-gap o60">
              <p className="updated small">
                <TimeAgo date={updated} hideSecondsText={TIMEAGO_TEXT} /></p>
              {isOlderThan(updated) && <WarningCircleIcon size={14} color="var(--d1)" title="This entry has not been updated in over 30 days." />}

            </div>
          </div>

     
            <div className="flex row small-gap center">

              <p className="tag regular">{classification}</p>
              {ownership < 100 && <div className="icon medium"> <UsersIcon /></div>}
              {!include_networth && (<div className="icon medium"><EyeSlashIcon /></div>)}
            </div>




          </div>
        </div>
  
    </>
  );
};

export default IndividualTileCard;
